module.exports = __webpack_public_path__ + "img/icon (14).279a8703.png";